import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Page from "src/components/Page";
import Home from "./Home";


function Index(props) {
  localStorage.removeItem("@storeAuctionLot");

  
  const callMeta = async () => {
    let dataSend = {
      title: 'Home Leon Gallery | Premier Philippine Art Gallery & Auction House',
      discription: 'Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions.',
      lotNo: '',
      canonical: 'https://leon-gallery.com/home',
      url: 'https://leon-gallery.com/home',
      imagUrl: 'https://leon-gallery.com/static/media/dddd.f96bbcbee8c8c2f5e3ee.png',
    };

    await fetch(`http://localhost:8081/meta`, {
      method: "POST",
      body: JSON.stringify(dataSend),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("data send here ", data);
      })
      .catch((error) => {
        // alert.error(error)
        console.log("error ", error);
      });
  }


useEffect(() => {
return callMeta();
},[])

  return (
    <>
    <Helmet>
        <meta itemprop="name" content="Home Leon Gallery | Premier Philippine Art Gallery & Auction House" />
    <meta property="og:title" content="Home Leon Gallery | Premier Philippine Art Gallery & Auction House" />
    <meta name="twitter:title" content="Home Leon Gallery | Premier Philippine Art Gallery & Auction House" />
    <meta itemprop="description" content="Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions." /> 
    <meta property="og:description" content="Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions." />  
    <meta name="twitter:description" content="Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions." />
    <meta itemprop="image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
<meta property="og:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" />
<meta name="twitter:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
</Helmet>
      <Page title="Home Leon Gallery | Premier Philippine Art Gallery & Auction House">
        <Home />
      </Page>
    </>
  );
}

export default Index;
